import apiClient from './client';
import type { Chapter, CreateChapterRequest } from '../types';

export const chaptersApi = {
  getBySeries: async (seriesId: string): Promise<Chapter[]> => {
    const response = await apiClient.get<Chapter[]>(`/chapters?series_id=${seriesId}`);
    return response.data;
  },

  getById: async (id: string): Promise<Chapter> => {
    const response = await apiClient.get<Chapter>(`/chapters/${id}`);
    return response.data;
  },

  create: async (data: CreateChapterRequest): Promise<{ id: string; archive_hash: string }> => {
    const response = await apiClient.post<{ id: string; archive_hash: string }>('/chapters', data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/chapters/${id}`);
  },

  getTranslation: async (id: string): Promise<{
    chapter_id: string;
    series_id: string;
    chapter_no: number;
    total_blocks: number;
    translated_blocks: number;
    blocks: Array<{
      page_no: number;
      block_no: number;
      original: string;
      translation: string;
    }>;
  }> => {
    const response = await apiClient.get(`/chapters/${id}/translation`);
    return response.data;
  },

  updateTranslation: async (id: string, blocks: Array<{ page_no: number; block_id: string; translated_text: string }>): Promise<{ success: boolean; updated: number }> => {
    const response = await apiClient.patch(`/chapters/${id}/translation`, { blocks });
    return response.data;
  },

  getTranslationHistory: async (id: string): Promise<{ edits: Array<{
    id: string;
    page_no: number;
    block_id: string;
    original_text: string;
    old_translated_text: string;
    new_translated_text: string;
    edited_by_email: string;
    edited_by_username: string;
    created_at: string;
  }> }> => {
    const response = await apiClient.get(`/chapters/${id}/translation/history`);
    return response.data;
  },
};

